import React from 'react';
import { Route, Redirect } from 'react-router-dom'
import * as Auth from './services/Auth.Service';
import { HeaderComponent } from './components/header/HeaderComponent';

/**
 * Component to access pages with login required
 * @param {object} {path: "url_accessed", data: {prop1: val, prop2: val, ...}, Component: {component_to_render}} 
 * @returns Route to access the component required if the user is logged or Redirect to the root site
 */

export const PrivateRoute = ({path, data, Component}) => (
	    <div className="wrap">
		<HeaderComponent />
		<Route path={path} component={({match})=> {
		    return (
			    <Component data={data} params={match.params} />
			    )
		    }} 
		/>
	    </div>
		)



// WEBPACK FOOTER //
// ./src/client/PrivateRoute.js